import React, { useEffect, useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import { TableBaseStyle, EMCTrendStyle } from './EMCTrendStyle';
import { EMCAlarmInfoModel, ConvertDateToStringByDate, ConvertDateToStringByString } from './EMCTrend';
import ColorLineText from '../../atoms/Text/ColorLineText';
import ItemComboBoxStr, { ComboBoxItemTypeS } from '../../atoms/ComboBox/ItemComboBoxStr';
import {
  EMCSettingType,
  EMCAlarmLogType,
  GetEMCSettings,
  GetEMCAlarmLogs,
  CreateSelectCombBoxItems,
  CreateSelectAlarmItems,
  CreateSelectAlarmCombBoxItems,
  CreateSelectAlarmLogList,
  GetEMCSettingsEst,
} from '../../../function/EMCModel';
import MessageDialog, { MessageDialogResponse } from '../../atoms/Dialog/MessageDialog';
import { useModal } from '../../../function/useModal';
import { SelectDataType, SelectMode, ConvertDateToStringByMarume } from './EMCTrend';
import dayjs from 'dayjs';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Button from '@material-ui/core/Button';
import ItemCalenderTimeEx from '../../atoms/Calendar/ItemCalenderTimeEx';
import EMCTrendErrorLogSelectDialog from './EMCTrendErrorLogSelectDialog';

type EMCTrendSelectItemProps = {
  buttonEnable: boolean;
  onClickDispButton: (target: SelectDataType) => void;
};
const EMCTrendSelectItem: React.FC<EMCTrendSelectItemProps> = (props) => {
  const { t } = useTranslation();
  const tableStyle = TableBaseStyle();
  const emcTrendStyle = EMCTrendStyle();
  const [selectComboBoxList, setSelectComboBoxList] = useState<ComboBoxItemTypeS[]>([]);
  const [buttonEnable, setButtonEnable] = useState<boolean>(props.buttonEnable);
  const [flgMsgDlg, actMsgDlg] = useModal<MessageDialogResponse>();
  const [emcAlarmLogs, setEmcAlarmLogs] = useState<EMCAlarmLogType[]>([]);
  const [dlgmsg, setDlgmsg] = useState<string>('');
  const msgdlg = flgMsgDlg ? <MessageDialog dialog={actMsgDlg} message={dlgmsg} /> : null;
  const [selectData, setSelectData] = useState<SelectDataType>({
    devIndex: '0',
    alramDate: '',
    selectDate: ConvertDateToStringByMarume(new Date()),
    selectMode: SelectMode.DAY_MODE,
  });
  const [openErrorLog, setOpenErrorLog] = useState<boolean>(false);
  const [selectAlramList, setSelectAlramList] = useState<EMCAlarmLogType[]>([]);

  /**
   * 初期表示　useEffect
   */
  useEffect(() => {
    upDatePage(true);
  }, []);

  /**
   * 上位でボタン状態変更時、反映させる
   */
  useEffect(() => {
    setButtonEnable(props.buttonEnable);
  }, [props.buttonEnable]);

  /**
   * 画面更新
   */
  const upDatePage = (isInitDisp: boolean) => {
    if (!isInitDisp) {
      //初期表示字にボタンを自動で押下するためボタン操作は不要
      setButtonEnable(false);
    }
    let emcList: EMCSettingType[] = [];
    let emcAlarmList: EMCAlarmLogType[] = [];
    let cmdItems: ComboBoxItemTypeS[] = [];
    let selectDevIndex: number = 0;
    let selectAlramList: EMCAlarmLogType[] = [];
    let selectAlramIndex: string = '';

    GetEMCSettingsEst()
      .then((r: EMCSettingType[]) => {
        console.debug(['★EMCTrendSelectPage - useEffect - GetEMCSettings', r]);
        emcList = r;
        return GetEMCAlarmLogs();
      })
      .then((r) => {
        console.debug(['EMCTrendSelectPage - useEffect - GetEMCAlarmLogss', r, emcList]);
        emcAlarmList = r;

        cmdItems = CreateSelectCombBoxItems(emcList);
        if (cmdItems.length != 0) {
          selectDevIndex = Number(cmdItems[0].key);
          selectAlramList = CreateSelectAlarmLogList(selectDevIndex, emcAlarmList);
          if (selectAlramList.length != 0) {
            selectAlramIndex = dayjs(selectAlramList[0].COL_DATE).format('YYYYMMDD');
          } else {
            selectAlramIndex = '';
          }
        }
        console.debug(['EMCTrendSelectPage - useEffect - CreateSelectAlarmItems', r, emcList]);

        setEmcAlarmLogs(emcAlarmList);
        setSelectComboBoxList(cmdItems);
        setSelectAlramList(selectAlramList);

        selectData.devIndex = String(selectDevIndex);
        selectData.alramDate = selectAlramIndex;
        selectData.selectDate = ConvertDateToStringByMarume(new Date());
        selectData.devIndex = String(selectDevIndex);
        if (isInitDisp) {
          //初期表示字にボタンを自動で押下する
          props.onClickDispButton(selectData);
        }
        setSelectData({ ...selectData });
      })
      .catch((e) => {
        setDlgmsg(t('EMCSettingPage.データ取得中にエラーが発生しました', 'データ取得中にエラーが発生しました'));
        actMsgDlg.open();
        console.error(['EMCSettingPage - useEffect - Error', e, emcList]);
      })
      .finally(() => {
        if (!isInitDisp) {
          //初期表示字にボタンを自動で押下するためボタン操作は不要
          setButtonEnable(false);
        }
      });
  };

  /**
   * 選択モード切替
   * @param e
   */
  const radioSelectAction = (e: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    selectData.selectMode = Number(e.target.value) === 1 ? SelectMode.ALRAM_MODE : SelectMode.DAY_MODE;
    setSelectData({ ...selectData });
  };
  /**
   * 機器選択変更Event
   * @param value
   */
  const onDevIndexSelectDataChange = (e: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    setButtonEnable(false);

    const selectDevIndex = Number(e.target.value);
    const selectAlramList = CreateSelectAlarmLogList(selectDevIndex, emcAlarmLogs);
    let selectAlramIndex: string = '';
    if (selectAlramList.length != 0) {
      selectAlramIndex = dayjs(selectAlramList[0].COL_DATE).format('YYYYMMDD');
    } else {
      selectAlramIndex = '';
    }

    setSelectAlramList([...selectAlramList]);
    selectData.devIndex = String(selectDevIndex);
    selectData.alramDate = '';
    setSelectData({ ...selectData });

    console.debug(['onDevIndexSelectDataChange selectDevIndex , selectData', selectDevIndex, selectData]);
    setButtonEnable(true);
  };
  /**
   * カレンダー値変更
   * @param value
   */
  const changeCalendarValueAction = (value: string) => {
    selectData.selectDate = value;
    setSelectData({ ...selectData });
  };

  /**
   * エラーログ日時選択ダイアログOPEN
   */
  const selectErrroLogDialogOpenAction = () => {
    setOpenErrorLog(true);
  };

  /**
   * エラーログ日時選択閉じる
   */
  const selectErrroLogDialogCloseAction = () => {
    setOpenErrorLog(false);
  };
  /**
   * エラーログ日時選択
   */
  const selectErrroLogDateAction = (target: string) => {
    setOpenErrorLog(false);
    selectData.alramDate = target;
    setSelectData({ ...selectData });
  };

  return (
    <Paper elevation={3} classes={{ root: emcTrendStyle.paperRoot }}>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell className={tableStyle.bodyCellCenter} width={250}>
              <ItemComboBoxStr
                itemList={selectComboBoxList}
                label={t('EMCTrendSelectItem.機器', '機器：')}
                value={selectData.devIndex}
                onChangeEvent={onDevIndexSelectDataChange}
              ></ItemComboBoxStr>
            </TableCell>
            <TableCell className={tableStyle.bodyCellCenter} width={300}>
              <RadioGroup
                row
                aria-label="gender"
                name="gender1"
                value={selectData.selectMode}
                onChange={radioSelectAction}
              >
                <FormControlLabel
                  classes={{ label: emcTrendStyle.muiTypography }}
                  value={SelectMode.DAY_MODE}
                  control={<Radio />}
                  label={t('EMCTrendSelectItem.日付選択', '当日')}
                />
                <FormControlLabel
                  classes={{ label: emcTrendStyle.muiTypography }}
                  value={SelectMode.ALRAM_MODE}
                  control={<Radio />}
                  label={t('EMCTrendSelectItem.アラーム発生日選択', 'アラーム発生日')}
                />
              </RadioGroup>
            </TableCell>
            <TableCell className={tableStyle.bodyCellCenter} width={350}>
              {selectData.selectMode === SelectMode.ALRAM_MODE ? (
                <>
                  <div style={{ display: 'inline-block', padding: '10px' }}>
                    {ConvertDateToStringByString(selectData.alramDate)}
                  </div>
                  <div style={{ display: 'inline-block' }}>
                    <Button
                      classes={{ root: emcTrendStyle.buttonRoot }}
                      variant="contained"
                      color="primary"
                      disabled={!buttonEnable}
                      disableElevation
                      onClick={(e) => {
                        selectErrroLogDialogOpenAction();
                      }}
                    >
                      {t('EMCTrendSelectItem.選択', '選択')}
                    </Button>
                  </div>
                </>
              ) : (
                <div>{ConvertDateToStringByString(selectData.selectDate)}</div>
                // <ItemCalenderTimeEx
                //   label={''}
                //   labelPosition={1}
                //   defaultValue={selectData.selectDate}
                //   onChange={changeCalendarValueAction}
                // />
              )}
            </TableCell>
            <TableCell className={tableStyle.bodyCellCenter} width={200}>
              <Button
                classes={{ root: emcTrendStyle.buttonRoot }}
                variant="contained"
                color="primary"
                disabled={!buttonEnable}
                disableElevation
                onClick={(e) => {
                  props.onClickDispButton(selectData);
                }}
              >
                {t('EMCTrendSelectItem.表示', '表示')}
              </Button>
            </TableCell>
          </TableRow>
        </TableBody>
        <EMCTrendErrorLogSelectDialog
          open={openErrorLog}
          onClose={selectErrroLogDialogCloseAction}
          onSelect={selectErrroLogDateAction}
          emcAlarmLogTypeList={selectAlramList}
        ></EMCTrendErrorLogSelectDialog>
      </Table>
    </Paper>
  );
};

export default EMCTrendSelectItem;
